// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { DockSystemInstance } from '../DockSystem';
import { Factory, FactoryAddPanelFrom } from '../panels/Factory';
import { GlobalFlags } from '@shared/commons/UtilsClasses/GlobalFlags';
import { IsAllowedPanel } from './WorkSpaceUtils';
export class WorkSpace {
    constructor(name, fileName) {
        this.visibleName = name;
        this.fileName = fileName;
        this.allPanels = {};
        this.allPanelsFromContainer = {};
        this.locked = Resources.isHidden('allowWorkspaceEdit');
        this.isDirty = false;
    }
    getPanelsAmount() {
        return Object.keys(this.allPanels).length;
    }
    // TODO. Exclusively for Brazil: hidden
    updateLocked(locked) {
        if (Resources.isHidden('allowWorkspaceEdit')) {
            this.locked = true;
        }
        else if (locked !== undefined) {
            this.locked = !!locked;
        }
    }
    serializePanels() {
        GlobalFlags.InstrumentSaveMode = true;
        const serializedPanelArray = [];
        const allPanels = this.allPanels;
        const insNamesDict = new Object();
        let i = 0;
        for (const key in allPanels) {
            const panel = allPanels[key];
            if (panel.skipOnSave) {
                continue;
            }
            panel.setWorkSpaceId(i++);
            const iSerializable = panel;
            serializedPanelArray.push(iSerializable.serialize());
            const ins = panel.getInstrument();
            if (ins) {
                insNamesDict[ins.GetInteriorID()] = 1;
            }
        }
        GlobalFlags.InstrumentSaveMode = false;
        return {
            panels: serializedPanelArray,
            dockSystemState: DockSystemInstance.getState(),
            insDict: insNamesDict
        };
    }
    loadPanels(serializedPanelsData) {
        if (!(serializedPanelsData === null || serializedPanelsData === void 0 ? void 0 : serializedPanelsData.dockSystemState) || !serializedPanelsData.panels) {
            return;
        }
        const dockSystemState = serializedPanelsData.dockSystemState
            ? JSON.parse(serializedPanelsData.dockSystemState)
            : null;
        const serializedPanelArray = serializedPanelsData.panels;
        for (let i = 0; i < serializedPanelArray.length; i++) {
            const serializedPanel = serializedPanelArray[i];
            const newPanel = Factory.addPanel(serializedPanel.name, FactoryAddPanelFrom.Restore);
            if (!isNullOrUndefined(serializedPanel.properties)) {
                newPanel.deserializeOldScheme(serializedPanel);
            }
            else {
                newPanel.deserialize(serializedPanel);
            }
            DockSystemInstance.addToArrRestore(newPanel);
        }
        DockSystemInstance.setState(JSON.stringify(dockSystemState));
    }
    clear() {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            allPanels[panelName].dispose();
        }
        this.allPanels = {};
        this.allPanelsFromContainer = {};
        DockSystemInstance.clearDocking();
    }
    // TODO.
    dispose() {
        this.clear();
    }
    addPanel(panel) {
        const isAllowedPanel = IsAllowedPanel(panel);
        this.allPanels[panel._guid] = panel;
        if (isAllowedPanel) {
            panel.populate(true);
        }
        else {
            panel.set('forbiddenPanel', true);
        }
        this.isDirty = true;
    }
    addPanelFromContainer(panel) {
        this.allPanelsFromContainer[panel._guid] = panel;
    }
    // TODO. Confusing name.
    removePanel(id) {
        delete this.allPanels[id];
    }
    removePanelFromContainer(panel) {
        delete this.allPanelsFromContainer[panel._guid];
    }
    createPropertiesHash(propArray) {
        const result = {};
        for (let i = 0, len = propArray.length; i < len; i++) {
            const prop = propArray[i];
            result[prop.name] = prop;
        }
        return result;
    }
    getElementByWSID(id) {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            const panel = allPanels[panelName];
            if (panel.get('workSpaceId') === id) {
                return panel;
            }
        }
        return null;
    }
    populate() {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            allPanels[panelName].populate();
            this.isDirty = true;
        }
    }
    TickAsync() {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            allPanels[panelName].TickAsync();
        }
    }
    updateSettings() {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            allPanels[panelName].updateSettings();
        }
    }
    localize() {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            allPanels[panelName].localize();
        }
    }
    RefreshPanelsWithInstrumentDescriptions(insArray) {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            allPanels[panelName].RefreshInstrumentDescriptions(insArray);
        }
    }
    themeChange() {
        const allPanels = this.allPanels;
        for (const panelName in allPanels) {
            allPanels[panelName].applyTheme();
        }
    }
    numberOfPanelByType(panelType) {
        const allPanels = this.allPanels;
        const allPanelsFromContainer = this.allPanelsFromContainer;
        let result = 0;
        for (const panelName in allPanels) {
            if (allPanels[panelName].getType() === panelType) {
                result++;
            }
        }
        for (const panelName in allPanelsFromContainer) {
            if (allPanelsFromContainer[panelName].getType() === panelType) {
                result++;
            }
        }
        return result;
    }
}
